module.exports = __webpack_public_path__ + "img/brown-logo.29806695.png";